<div class="slideout-content">
    <!-- Modal to add new user starts-->
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0" [formGroup]="pageForm">
                <button type="reset" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-page')">
                    ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">{{page ? 'Sayfa Güncelle' : 'Sayfa Ekle'}}</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="row">
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="title">Sayfa Başlığı</label>
                                <input type="text" formControlName="title" class="form-control"
                                    placeholder="Sayfa Adı Giriniz." />
                                <div *ngIf="pageForm.get('title').invalid">
                                    <small class="text-danger" *ngIf="pageForm.get('title').errors.required">Sayfa adı
                                        zorunludur.</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="url">Url</label>
                                <input type="text" formControlName="url" class="form-control"
                                    placeholder="Url Giriniz." />
                            </div>
                        </div>

                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="icon">İkon</label>
                                <input type="text" formControlName="icon" class="form-control"
                                    placeholder="İkon Giriniz." />
                                <div *ngIf="pageForm.get('icon').invalid">
                                    <small class="text-danger" *ngIf="pageForm.get('icon').errors.required">İkon girmek
                                        zorunludur.</small>

                                </div>
                            </div>
                        </div>

                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="type">Tip</label>
                                <input type="text" formControlName="type" class="form-control"
                                    placeholder="Tip Giriniz." />
                                <div *ngIf="pageForm.get('type').invalid">
                                    <small class="text-danger" *ngIf="pageForm.get('type').errors.required">Tip girmek
                                        zorunludur</small>

                                </div>
                            </div>
                        </div>
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="parentId">Üst Sayfa</label>
                                <select class="form-control" id="basicSelect" formControlName="parentId">
                                    <option value="0">Sayfa Seç</option>
                                    <option *ngFor="let item of getAllPage" [value]="item.id">{{item.title}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="type">Sıra Numarası</label>
                                <input type="text" formControlName="order" class="form-control"
                                    placeholder="Sıralama numarası Giriniz." />
                                <div *ngIf="pageForm.get('order').invalid">
                                    <small class="text-danger" *ngIf="pageForm.get('order').errors.required">Sıralama numarası
                                        zorunludur</small>

                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" [disabled]="pageForm.invalid" class="btn btn-primary col-10 mb-1 ml-1"
                        (click)="onSubmit()" rippleEffect>
                        {{ isEditMode ? 'Güncelle' : 'Ekle' }}
                    </button>
                    <button type="reset" class="btn btn-outline-secondary col-10 mb-1 ml-1"
                        (click)="toggleSidebar('create-page')" rippleEffect>
                        İptal
                    </button>
                </div>

            </form>

        </div>
    </div>
</div>